import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-info-card',
  templateUrl: './skeleton-info-card.component.html',
  styleUrls: ['./skeleton-info-card.component.scss']
})
export class SkeletonInfoCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
